import { USER_ROLES } from 'shared/enums';

export const hasAdminRole = user => !!user?.roles?.includes(USER_ROLES.ADMIN);
